import React from 'react';
import { USER_ROLE_SET } from '../../../../config/UserRoleSet';
import './UserManagerInfo.css'
import Linker from '../../linker/Linker';
import * as path from '../../../../route/PathConfig';
const UserManagerInfo = (props) => {

  return (
    <div id="userInformation">
      <div id="userInfoTitBtn">
        <div id="userInfoTit">User Information</div>
        <div id="manageBtn">
          {props.selectedUser.userID ?
            <Linker path={`${path.ADMINACCOUNTEDIT}/${props.selectedUser.userID}`}>
              <a className="button purple_line" >편집</a>
            </Linker>
            :undefined
          }
        </div>
      </div>
      {props.selectedUser.userID ? 
        <div className="adminUserInfo">
          <table className="adminUserTablesty">
            <tr>
              <td colspan="2">
                <span className="userTxt">
                  {props.selectedUser.fullname}
                </span>
              </td>
            </tr>
            <tr>
              <td width="14%" className="tit">Email</td>
              <td width="86%">
                {props.selectedUser.email}
              </td>
            </tr>
            <tr>
              <td width="14%" className="tit">Company</td>
              <td width="86%">
                {props.selectedUser.company}
              </td>
            </tr>
            <tr>
              <td width="14%" className="tit">Role</td>
              <td width="86%">
                {USER_ROLE_SET.find(item=>item.role==props.selectedUser.role).name}
              </td>
            </tr>
            <tr>
              <td width="14%" className="tit">ExpireDate</td>
              <td width="86%">
                {props.selectedUser.expireDate.substring(10,0)}
              </td>
            </tr>
          </table>
        </div>
      :undefined
      }
    </div>
  )
}

export default UserManagerInfo;